// extracted by mini-css-extract-plugin
export default {"info-label":"replace-tracker-form_info-label__0n82V","form":"replace-tracker-form_form__yHglC","return-app-link":"replace-tracker-form_return-app-link__JIShU"};